import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, OnInit,AfterViewInit ,ElementRef, Inject, Renderer2, PLATFORM_ID } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit,AfterViewInit  {
  ShowCard:any
  activeTab: string = 'id';
  isBrowser!: boolean;
  index = 0;            // current slide index
  totalSlides = 2;      // number of slides (groups of 2 cards)
  intervalId: any;      // store interval reference
  constructor(private el: ElementRef,
     private titleService: Title, private metaService: Meta,
        private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, private router:Router,private route: ActivatedRoute,
         @Inject(PLATFORM_ID) private platformId: Object
  ){
     this.isBrowser = isPlatformBrowser(this.platformId);
  }
  ngOnInit(): void {
    this.setMetaTags();
    this.setCanonicalUrl();
  this.route.queryParams.subscribe(params => {
    if (params['tab']) {
      this.activeTab = params['tab'];

      setTimeout(() => {
        document.getElementById('servicesSection')?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    }
  });
     if (this.isBrowser) {
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }
    //    this.intervalId = setInterval(() => {
    //   this.nextSlide();
    // }, 5000);
  }

  ngAfterViewInit(): void {
  if (!this.isBrowser) return;

  const cards: NodeListOf<HTMLElement> =
    this.el.nativeElement.querySelectorAll('.process-card');

  const processFlow =
    this.el.nativeElement.querySelector('.process-flow');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        cards.forEach((card, index) => {
          setTimeout(() => {
            card.classList.add('active');
          }, index * 1200);
        });
        observer.disconnect();
      }
    });
  }, { threshold: 0.3 });

  if (processFlow) {
    observer.observe(processFlow);
  }

  this.showVerification();
}
  // ngAfterViewInit(): void {
  //   const cards: NodeListOf<HTMLElement> = this.el.nativeElement.querySelectorAll('.process-card');
  //   const processFlow = this.el.nativeElement.querySelector('.process-flow');

  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
          
  //         cards.forEach((card, index) => {
  //           setTimeout(() => {
  //             card.classList.add('active');
  //           }, index * 1200); 
  //         });
  //         observer.disconnect(); 
  //       }
  //     });
  //   }, { threshold: 0.3 });

  //   if (processFlow) {
  //     observer.observe(processFlow);
  //   }

  //   this.showVerification()
    
  // }

  ngOnDestroy(): void {
    // clear interval when component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

showVerification(){

  if (!this.isBrowser) return;
const section: HTMLElement = this.el.nativeElement.querySelector('.verification-section');
const intro: HTMLElement = this.el.nativeElement.querySelector('.intro-content');
const box: HTMLElement = this.el.nativeElement.querySelector('.verification-box');
const logoInside: HTMLElement = this.el.nativeElement.querySelector('.logo-inside');
const cards: NodeListOf<HTMLElement> = this.el.nativeElement.querySelectorAll('.verification-card');


const observerIntro = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      intro.classList.add('hidden');
    } else {
      intro.classList.remove('hidden');
    }
  });
}, {
  threshold: 0.5,              // 50% of element visible
  rootMargin: "-40% 0px -40% 0px" // triggers when centered
});

observerIntro.observe(section);


const observerBox = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      box.classList.add('active');
      logoInside.classList.add('active');
      cards.forEach((card, index) => {
        setTimeout(() => card.classList.add('active'), index * 300);
      });
    } else {
      box.classList.remove('active');
      logoInside.classList.remove('active');
      cards.forEach(card => card.classList.remove('active'));
    }
  });
}, { threshold: 0.3 });

observerBox.observe(box);


    }

private setMetaTags(): void {
        // Set page title (works for both server and client)
        this.titleService.setTitle('FA Check | Business Verification Service');
       
        // Update or add meta tags
        this.metaService.updateTag({ name: 'description', content: 'Verify businesses with FA Check’s Business Verification Service. Ensure compliance, reduce fraud, and validate company data in real time.' });
        // this.metaService.updateTag({ name: 'author', content: 'Your Name' });
       
        // For keywords, use updateTag with proper attribute
        this.metaService.updateTag({ name: 'keywords', content: 'Business verification service, Online Business verification service, Business verification, Digital Verification Service, Online Verification Service, Digital identity verification, identity verification service, identity business verification service, online identity verification service, Digital identity verification service, best business verification service.'
 });
       
        // Open Graph tags
        this.metaService.updateTag({ property: 'og:title', content: 'FA Check | Business Verification Service' });
        this.metaService.updateTag({ property: 'og:description', content: 'Verify businesses with FA Check’s Business Verification Service. Ensure compliance, reduce fraud, and validate company data in real time.' });
        this.metaService.updateTag({ property: 'og:url', content: `https://facheck.in${this.router.url}` });
        this.metaService.updateTag({ property: 'og:type', content: 'website' });
       
        // Twitter tags
        this.metaService.updateTag({ name: 'twitter:title', content: 'FA Check | Business Verification Service' });
        this.metaService.updateTag({ name: 'twitter:description', content: 'Verify businesses with FA Check’s Business Verification Service. Ensure compliance, reduce fraud, and validate company data in real time.' });
        this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
       
        // You can also add tags if they don't exist
        // this.addTagIfNotExists('og:image', { property: 'og:image', content: 'https://quickrentpay.com/assets/images/og-image.jpg' });
        // this.addTagIfNotExists('twitter:image', { name: 'twitter:image', content: 'https://quickrentpay.com/assets/images/twitter-image.jpg' });
    }
 
 setCanonicalUrl(): void {
    // Remove query parameters for clean canonical URL
    const cleanUrl = this.router.url.split('?')[0];
    const canonicalUrl = `https://facheck.in${cleanUrl}`;
   
    // Use the same DOM manipulation on both server and client
    this.updateCanonicalLink(canonicalUrl);
  }
 
  private updateCanonicalLink(url: string): void {
    // Find existing canonical link
    const existingLink = this.document.querySelector("link[rel='canonical']");
   
    if (existingLink) {
      // Update existing link if href is different
      const currentHref = existingLink.getAttribute('href');
      if (currentHref !== url) {
        this.renderer.setAttribute(existingLink, 'href', url);
      }
    } else {
      // Create new canonical link if it doesn't exist
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(this.document.head, link);
    }
  }

 nextSlide(): void {
    this.index = (this.index + 1) % this.totalSlides;
  }

  getTransform(): string {
    const offset = -this.index * 100;
    const rotation = this.index % 2 === 0 ? '0deg' : '-20deg';
    return `translateX(${offset}%) rotateY(${rotation})`;
  }

  setTab(tab: string) {
  
    
    this.activeTab = tab;
  }
}
